export default __webpack_public_path__ + "static/media/Ficha Técnica - Acerola Integral.24ab70d6.pdf";